import { render } from "./Toastiff.vue?vue&type=template&id=630a8c50"
import script from "./Toastiff.vue?vue&type=script&lang=js"
export * from "./Toastiff.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__